import { Element } from "@craftjs/core";
import { FlexBox } from "@/src/components/FlexBox";
import {Action as Button} from "@/src/components/Action";

export function Navigation(props: any) {
  return (
    <Element canvas is={FlexBox} id={"navigation"} className={"p-0"}>
      <Button />
      <Button />
    </Element>
  );
}
